export const DECLINED_COVERAGE_PLAN_LOOKUP_CODE = 'decline';
export const MEDICAL_BENEFIT_CATEGORY = 'Medical';
export const HEALTH_WELLNESS_BENEFIT_CATEGORY = 'Health & Wellness';
export const WEALTH_FINANCIAL_BENEFIT_CATEGORY = 'Wealth & Financial';
export const LIFESTYLE_BENEFIT_CATEGORY = 'Lifestyle';
